import * as $ from 'jquery';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { OrderTransferService } from './../../../services/seed/order-transfer.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { DealerService } from './../../../services/seed/dealer.service';
import { ConfigService } from './../../../services/infrastructure/config.service';

import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { GrowerOrderItemVM } from '../../../models/GrowerOrderItemVM';
import { DashboardFilter } from './../../../models/DashboardFilter';
import { DealerOrderTransferVM } from '../../../models/DealerOrderTransferVM';
import { MasterConstants } from '../../constants/master-constants';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { CommonService } from '../../../services/common/common.service';
import { DealerOrderItemVM } from '../../../models/DealerOrderItemVM';

@Component({
  selector: 'app-dealer-order-transfer',
  templateUrl: './dealer-order-transfer.component.html',
  styleUrls: ['./dealer-order-transfer.component.scss']
})

export class DealerOrderTransferComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  orderFromTo: DealerOrderTransferVM = null;
  changeListDS: GrowerOrderItemVM[];
  orderFromToList: DealerOrderTransferVM[] = [];
  copyOrderFromToList: DealerOrderTransferVM[] = [];
  fromDealer: any;
  fromDealerOrderId: number;
  toDealer: any;
  accountLoading: any;
  accountId: any;
  accountEmail: any;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  itemList: string[];
  hasChangeAdded = false;
  transferRecord: any;

  // //component variables at component initialize
  isTransfer = false;
  dealerOrderList: any[];
  toDealerList = new Array();
  public dashboardFilter: DashboardFilter;

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  toSellerId: any;
  selectedDealer: string;
  originalUnitCount = 0;
  modifiedUnitCount = 0;
  isNotValid = false;
  toAccountNumber: number;
  errorMsgs = new Array();
  showErrorBlock = false;
  nextErrorId = 0;
  index = 0;
  currentErrorRow = 1;
  isSubscriptionAccess = true;

  constructor(
    public sliderModelService: SliderModelService,
    public matDialog: MatDialog,
    public loaderService: LoaderService,
    private router: Router,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    private orderTransferService: OrderTransferService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private dealerService: DealerService,
    private commonService: CommonService,
    @Inject('BASE_URL') public baseUrl: any) {
    this.dashboardFilter = new DashboardFilter();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    // load header crop year and company code
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.subscription.push(this.sliderModelService.initializeCompValue.subscribe(x => {
      this.accountId = +x;
    }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }

    this.subscription.push(this.sliderModelService.order2OrderUnit.subscribe(x => {
      this.bindOrderTransferList(JSON.parse(JSON.stringify(x)));
      if (x.length > 0) {
        this.fromDealerOrderId = x[0].dealerOrderNumber;
      }
    }));

    this.sliderModelService.order2OrderUnit.observers = [];

    this.subscription.push(this.sliderModelService.accountInfo.subscribe(x => {
      this.fromDealer = JSON.parse(JSON.stringify(x));
    }));

    this.sliderModelService.accountInfo.observers = [];

    // If header dropdown value exist
    if (this.headerCompany && this.headerYear) {
      this.getDealerAccount(this.accountId);
    }
    this.subscription.push(this.sliderModelService.sliderCloseRqt.subscribe(x => {
      this.sliderModelService.setData2(this.transferRecord);
      this.sliderModelService.sliderCloseRqt.observers = [];
    }));

  }

  // filter function
  public accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.retailerName.toLocaleLowerCase().indexOf(term) > -1
      || item.shipToAccount.toString().indexOf(term) > -1
      || item.retailerAddress1.toLocaleLowerCase().indexOf(term) > -1
      || item.retailerCity.toLocaleLowerCase().indexOf(term) > -1
      || item.retailerState.toLocaleLowerCase().indexOf(term) > -1
      || item.retailerZipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // get grower List
  getDealerAccount(accountNo: number) {
    if (!isNaN(accountNo)) {
      this.subscription.push(this.dealerService.getDealerAccountList(this.headerYear, 0).subscribe(result => {
        this.dealerOrderList = result as any[];
        if (this.dealerOrderList && this.dealerOrderList.length > 0) {
          let fromDealer = this.dealerOrderList.find(x => x.shipToAccount == accountNo);
          this.toDealerList = this.dealerOrderList.filter(x => x.shipToAccount != accountNo);
          let ribStatus = false;
          if (this.orderFromToList) {
            const hasTrue = this.orderFromToList.some(element => element.isRib === true);
            const hasFalse = this.orderFromToList.some(element => element.isRib === false);

            if (hasTrue == false && hasFalse == true) {
              ribStatus = true;
            }
          }

          this.toDealerList.forEach(x => {
            x.isValidAccount = !(x.isRibState == true && ribStatus === true);
          });

          //Disabled Invalid options
          this.toDealerList = this.toDealerList.map((p) =>
            p.isValidAccount ? p : { ...p, disabled: true }
          );
        }
      }, error => LolLoggerService.error(error)));
    }
  }
  // Qty change on +/- sign click
  geuValueChange(action: string, productItem: any) {
    const o2OItem = this.orderFromToList.find(x => x.rowId == productItem.rowId);
    const index = this.orderFromToList.findIndex(x => x.rowId == productItem.rowId);
    if (o2OItem && index != -1) {
      if (action == 'decrease') {
        // This condition is applied when we enter Unit manually more than TransferableUnits
        if ((+productItem.ToPrimaryQty) > (+o2OItem.TransferableUnits)) {
          o2OItem.ToPrimaryQty = Math.abs((+o2OItem.TransferableUnits));
        }
        else {
          if ((Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * productItem.Conv - productItem.Conv) >= 0) {
            const valueBeforeDec = +productItem.ToPrimaryQty;

            productItem.ToPrimaryQty = Math.floor(+productItem.ToPrimaryQty / +productItem.Conv) * +productItem.Conv;
            // update correct values to variable after rounding to conv factor
            o2OItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty));
            o2OItem.ToSecondaryQty = (+o2OItem.ToPrimaryQty) / (+productItem.Conv);

            if (valueBeforeDec == +productItem.ToPrimaryQty) {
              // decrease value for ToDealer
              o2OItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty) - (+productItem.Conv));
              o2OItem.ToSecondaryQty = (+o2OItem.ToPrimaryQty) / (+productItem.Conv);
            }
          }
        }
        // increase value for FromDealer
        o2OItem.RemainingQuantity = Math.abs((+o2OItem.TransferableUnits) - (+o2OItem.ToPrimaryQty));
        o2OItem.FromSecondaryQty = (+o2OItem.FromPrimaryQty) / (+productItem.Conv);
      }

      if (action == 'increase') {
        if (+productItem.RemainingQuantity > 0 && (((+productItem.RemainingQuantity) - (+productItem.Conv) >= 0) ||
          (Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * productItem.Conv <= productItem.OriginalFromQty))) {
          const valueBeforeInc = +productItem.ToPrimaryQty;

          productItem.ToPrimaryQty = Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * +productItem.Conv;
          // update correct values to variable after rounding to conv factor
          o2OItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty));
          o2OItem.ToSecondaryQty = (+o2OItem.ToPrimaryQty) / (+productItem.Conv);

          if (valueBeforeInc == +productItem.ToPrimaryQty) {
            // decrease value for ToDealer
            o2OItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty) + (+productItem.Conv));
            o2OItem.ToSecondaryQty = (+o2OItem.ToPrimaryQty) / (+productItem.Conv);
          }
          // decrease value for FromDealer
          o2OItem.RemainingQuantity = Math.abs((+o2OItem.TransferableUnits) - (+o2OItem.ToPrimaryQty));

          o2OItem.FromSecondaryQty = (+o2OItem.FromPrimaryQty) / (+productItem.Conv);
        }
      }
      this.validateLineItem(productItem, 'dealerUnit');
      this.orderFromToList[index] = JSON.parse(JSON.stringify(o2OItem));
      // calculat total unit transfer
      this.calculateTotalUnitTransfer();
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.orderFromToList.length });
      if (productItem.LineErrors.errors.length <= 0) {
        this.cloneTransferListObj(this.orderFromToList);
      }
    }
  }

  validateSelectedCount(element, d2dUnits: number) {
    const d2dItemOld = this.copyOrderFromToList.find(x => x.rowId == element.rowId);
    const d2dItem = this.orderFromToList.find(x => x.rowId == element.rowId);
    const index = this.orderFromToList.findIndex(x => x.rowId == element.rowId);

    if (d2dItem && d2dItemOld && index != -1) {
      // get change value to calculate FromDealer qty
      const changedValue = +d2dUnits - (+d2dItemOld.ToPrimaryQty);
      if (+d2dUnits <= +d2dItem.TransferableUnits) {
        // update ToGrower qty
        d2dItem.ToPrimaryQty = +d2dUnits;
        d2dItem.ToSecondaryQty = +d2dItem.ToPrimaryQty / (+d2dItem.Conv);

        if (+changedValue >= 0) {
          // update FromGrower qty
          d2dItem.FromSecondaryQty = +d2dItem.FromPrimaryQty / (+d2dItem.Conv);
        }
        else {
          // increase FromGrower qty
          d2dItem.FromSecondaryQty = +d2dItem.FromPrimaryQty / (+d2dItem.Conv);
        }
        d2dItem.RemainingQuantity = Math.abs((+d2dItem.TransferableUnits) - (+d2dItem.ToPrimaryQty));
      }
      else {
        // This code is implemented because when we enter Units more than TransferableUnits manually and then focus out from textbox then remaining quantity was showing wrong value.
        d2dItem.RemainingQuantity = 0;
      }
      this.validateLineItem(d2dItem, 'dealerUnit');
      this.orderFromToList[index] = JSON.parse(JSON.stringify(d2dItem));
      this.calculateTotalUnitTransfer();
      if (d2dItem.LineErrors.errors.length <= 0) {
        this.cloneTransferListObj(this.orderFromToList);
      }
    }
  }

  bindOrderTransferList(orderList) {
    // initial data binding
    this.orderFromToList = [];
    orderList.forEach(item => {
      this.orderFromTo = new DealerOrderTransferVM();
      this.orderFromTo.rowId = item.rowId;
      this.orderFromTo.CropYear = this.headerYear;
      this.orderFromTo.CompanyCode = this.headerCompany;
      this.orderFromTo.ItemId = item.itemID;
      this.orderFromTo.ItemNumber = item.itemNumber;
      this.orderFromTo.ItemDescription = item.itemDescription;
      this.orderFromTo.Brand = item.brand;
      this.orderFromTo.MarketingBrand = item.marketingBrand;
      this.orderFromTo.PrimaryUom = item.primaryUOM;
      this.orderFromTo.SecondaryUom = item.secondaryUOM;
      this.orderFromTo.Conv = item.conv;
      this.orderFromTo.FromShipToAccount = item.shipToAccount;
      this.orderFromTo.ToShipToAccount = 0;
      this.orderFromTo.FromPrimaryQty = item.dealerUnits;
      this.orderFromTo.FromSecondaryQty = item.dealerUnits == 0 ? 0 : item.dealerUnits / item.conv;
      this.orderFromTo.OriginalFromQty = item.dealerUnits;
      this.orderFromTo.ModifiableUnit = item.modifiableUnit;
      this.orderFromTo.ToPrimaryQty = 0;
      this.orderFromTo.ToSecondaryQty = 0;
      this.orderFromTo.FromOrderId = item.dealerOrderID;
      this.orderFromTo.FromOrderNo = item.dealerOrderNumber;
      this.orderFromTo.FromOrderItemId = item.dealerOrderItemId;
      this.orderFromTo.LineErrors = item.lineErrors;
      this.orderFromTo.FromChangeType = 'TDF';
      this.orderFromTo.ToChangeType = 'TDT';
      this.orderFromTo.TransferableUnits = 0;
      this.orderFromTo.RemainingQuantity = 0;
      this.orderFromTo.EmailTo = this.accountEmail;
      this.orderFromTo.TransferableUnits = item.transferableUnits;
      this.orderFromTo.DealerModifiableUnits = item.dealerModifiableUnits;
      this.orderFromTo.SoftCommitUnits = item.softCommitUnits;
      this.orderFromTo.seedNonReturnable = item.seedNonReturnable;
      this.orderFromTo.isRib = item.isRib;
      this.orderFromTo.isValidForRibTransfer = true;
      this.orderFromToList.push(this.orderFromTo);
    });

    this.itemList = [];
    this.orderFromToList.forEach(x => {
      this.itemList.push(x.ItemNumber);
    });

    // clone modified object
    this.cloneTransferListObj(this.orderFromToList);

    this.calculateTotalUnitTransfer();
  }

  confirmToTransfer() {
    const softCommitUsedList = this.orderFromToList.filter(x => x.ToPrimaryQty > x.DealerModifiableUnits);
    // display confirm message if any of the items using soft commit unit
    if (softCommitUsedList && softCommitUsedList.length > 0) {
      const title = 'Confirm';
      let rows = '';
      softCommitUsedList.forEach(element => {
        rows += '<tr class="mat-row">';
        rows += '<td class="mat-cell">' + element.ItemNumber + '</td>';
        rows += '<td class="mat-cell">' + element.ItemDescription + '</td>';
        rows += '</tr>';
      });
      const message = `<p>The following products are being packaged, and cannot be modified after transfer is complete:</p>
            <div class="row">
                <div class="col-md-12 padding-r0">
                    <div class="tableContainer">
                        <table class="matTables mat-table">
                            <thead>
                                <tr class="mat-header-row">
                                    <th class="mat-header-cell">Item number</th>
                                    <th class="mat-header-cell">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>`;
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        panelClass: 'confirmModal',
        data: { title: title, htmlMessage: message, labelYes: 'OK to continue', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected ok
        if (result == true) {
          //this.transferUnits();
          this.validateTransferDealerOrder();
        }
      }));
    }
    else {
      this.validateTransferDealerOrder();
      //this.transferUnits();
    }
  }
  validateTransferDealerOrder() {
    if (!this.validateEmail()) {
      this.loaderService.setLoaderStatus(true);
      let orderList = this.orderFromToList.filter(x => x.ToPrimaryQty != 0);

      orderList.map(item => {
        item.IsSelected = true;
      });

      this.subscription.push(this.orderTransferService.validateTransferDealerOrder(orderList).subscribe((response: any) => {
        let result = response.validatedList;
        if (result && result.filter(x => x.errors.length > 0).length == 0) {
          this.transferRecord = {
            validateResponse: response,
            transferList: this.orderFromToList.filter(x => x.ToPrimaryQty != 0)
          };

          this.sliderModelService.sliderCloseRqt.next(true);
          this.sliderModelService.close();
        }
        else {
          this.orderFromToList.forEach(data => {
            data.LineErrors.errors = [];
            const itemErrors = result.find(result => result.itemNumber == data.ItemNumber);
            if (itemErrors) {
              itemErrors.errors.forEach(itemError => {
                data.LineErrors.errors.push({ id: itemError.id, error: itemError.error });

                if (data.LineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                  this.errorMsgs.push(data.LineErrors);
                }
              });
            }
          });
        }
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
    }
    else {
      this.toastrService.warning('Enter a valid email.');
    }
  }
  transferUnits() {
    if (!this.validateEmail()) {
      if (this.orderFromToList.filter(x => x.ToPrimaryQty != 0).length > 0) {
        this.loaderService.setLoaderStatus(true);
        this.orderFromToList[0].EmailTo = this.accountEmail;
        this.subscription.push(this.orderTransferService.transferDealerOrder(this.orderFromToList.filter(x => x.ToPrimaryQty != 0)).subscribe((result: any) => {
          if (result && result.dealerOrderId != 0) {
            this.toastrService.success('Your order has been saved');
            const dealerOrderId = result.dealerOrderId as number;
            this.sliderModelService.close();
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.router.navigate(['/orders/dealer-order-view', 0, +dealerOrderId, this.toAccountNumber]);
          }
          else {
            this.orderFromToList.forEach(data => {
              data.LineErrors.errors = [];
              const itemErrors = result.dealerOrderItems.find(result => result.itemNumber == data.ItemNumber);
              if (itemErrors) {
                itemErrors.errors.forEach(itemError => {
                  data.LineErrors.errors.push({ id: itemError.id, error: itemError.error });

                  if (data.LineErrors.errors.length > 0) {
                    this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                    this.errorMsgs.push(data.LineErrors);
                  }
                });
              }
            });
          }
          this.loaderService.setLoaderStatus(false);
        }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
      }
    }
    else {
      this.toastrService.warning('Enter a valid email.');
    }
  }

  calculateTotalUnitTransfer() {
    this.originalUnitCount = this.orderFromToList.reduce((sum, item) => sum + +item.TransferableUnits, 0);
    this.modifiedUnitCount = this.orderFromToList.reduce((sum, item) => sum + +item.ToPrimaryQty, 0);
  }

  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    return this.isNotValid;
  }

  selectToDealer(toDealer) {
    this.resetToDealerData();

    if (toDealer) {
      if (toDealer.billingAddressType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
        this.toDealer = toDealer;
        this.isTransfer = true;
        this.toAccountNumber = 0;
        if (toDealer.shipToAccount) {
          this.toAccountNumber = toDealer.shipToAccount;
        }

        const data = {
          CompanyCode: this.headerCompany,
          CropYear: this.headerYear,
          FromAccountNumber: this.accountId,
          ToAccountNumber: toDealer.shipToAccount,
          ItemNumbers: this.itemList,
        };

        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.orderTransferService.getAllocationAvailability(data).subscribe((result: any) => {
          if (result && result.status) {
            this.orderFromToList.forEach(item => {
              const matchItem = result.resultData.find(x => x.itemNumber == item.ItemNumber);
              if (matchItem) {
                item.ToShipToAccount = toDealer.shipToAccount;
                item.TransferableUnits = matchItem.transferableUnits;
                item.RemainingQuantity = +item.TransferableUnits - +item.ToPrimaryQty;
              }
              
              if (toDealer.isRibState) {
                if (item.isRib) {
                  item.isValidForRibTransfer = true;
                }
                else {
                  item.isValidForRibTransfer = false;
                }
              }
              else {
                item.isValidForRibTransfer = true;
              }
            });

            // clone modified object
            this.cloneTransferListObj(this.orderFromToList);
            this.calculateTotalUnitTransfer();
          }
          else {
            if (result) {
              this.toastrService.info(result.message);
            }
            else {
              this.toastrService.error('No Record Found.');
            }
          }
          this.loaderService.setLoaderStatus(false);
        }, (error => {
          LolLoggerService.error(error);
          this.loaderService.setLoaderStatus(false);
        })));
      }
      else {
        this.selectedDealer = null;
        this.isTransfer = false;
        this.resetToDealerData();
        this.toastrService.warning('Account not eligible for Ordering.');
      }
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { transferTarget: true });
    }
    else {
      this.toDealer = null;
      this.isTransfer = false;
      this.resetToDealerData();
    }
  }

  // To show hide product deactivation info block
  //blockHideShow(id: number, flag: boolean) {
  //  if (flag) {
  //    $('#sub_' + id).addClass('showHide');
  //    $('#main_' + id).addClass('prod-unavail-info-hover');
  //  }
  //  else {
  //    $('#sub_' + id).removeClass('showHide');
  //    $('#main_' + id).removeClass('prod-unavail-info-hover');
  //  }
  //}

  resetToDealerData() {
    this.orderFromToList.forEach(item => {
      // reset values to 0
      item.ToPrimaryQty = 0;
      item.ToSecondaryQty = 0;
      item.TransferableUnits = 0;
      item.RemainingQuantity = 0;
      item.LineErrors = { 'rowId': item.rowId, 'errors': [] };
    });
  }

  onCancel() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          this.sliderModelService.close();
        }
      }));
    }
    else { this.sliderModelService.close(); }
  }

  cloneTransferListObj(orderList) {
    this.copyOrderFromToList = JSON.parse(JSON.stringify(orderList));
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    if (validateField != '') {
      if (validateField == 'dealerUnit') {
        if (item.ToPrimaryQty > item.TransferableUnits) {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'dealerUnits');
          item.LineErrors.errors.push({
            id: 'dealerUnits', error: 'Cannot increase the quantity more than transferable units. ' + item.RemainingQuantity + ' Equivalent Units remaining.'
          });
        }
        else {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'dealerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (item.ToPrimaryQty != 0 && item.ToPrimaryQty % item.Conv != 0) {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'conv');
          item.LineErrors.errors.push({ id: 'conv', error: 'Please re-enter your transfer Units in multiples of ' + item.Conv });
        }
        else {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'conv');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }

    if (item.LineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.LineErrors);
    }
    if (this.errorMsgs.length > 0) {
      this.isTransfer = false;
    }
    else {
      this.isTransfer = true;
    }
    return item;
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
